<template>
  <div style="background: #f7f7f7">
    <!--Telescopio 1-->
    <v-container fluid class="pt-10">
      <v-row no-gutters>
        <v-col lg="6" md="6" sm="12" cols="12">
          <!--Carrousel -->
          <v-carousel show-arrows-on-hover cycle hide-delimiters height="600">
            <v-carousel-item
              v-for="(item,i) in imagenes"
              :key="i"
              :src="item.src"
              reverse-transition="fade-transition"
              transition="fade-transition"
            ></v-carousel-item>
          </v-carousel>
          <!--Fin Carrousel -->
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12" class="pr-10">
          <!--Info Telescopios -->
        <br>
        <br>
        <br>
          <p
            class="title font-weight-black text-center pt-3 pb-6"
            style="color: #777777"
          >PLANEWAVE CDK 20</p>
          <v-divider></v-divider>
          <p
            class="body-2 text-center pt-10 pb-10"
            style="color: #777777"
            v-text="$t('descripciontelescopio[0]')"
          ></p>
          <v-divider></v-divider>
          <div class="text-lg-center text-md-center text-sm-center text-center mt-4">
            <v-btn
              small
              class="caption white--text"
              color="#E8175D"
              @click="dialog = true"
              v-text="$t('especificacionestenicas[0]')"
            ></v-btn>
          </div>
          <!--Fin Info Telescopios -->
        </v-col>
      </v-row>
    </v-container>
    <!--Fin Telescopio 1-->
    <!--Especificaciones Tecnicas-->
    <v-dialog v-model="dialog" max-width="1200" max-height="1200">
      <v-card class="pa-2">
        <v-card-title style="background: #EA296A">
          <p class="body-2 white--text my-auto mx-auto">{{titulos[0]}}</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row class="mr-2">
            <v-col cols="4">
              <v-img :src="scrplanwave[0]" align="center"></v-img>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in telescope" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in especificaciones1" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="pa-2">
            <v-card-title style="background: #EA296A">
              <p class="body-2 white--text my-auto mx-auto">{{titulos[1]}}</p>
            </v-card-title>
            <v-card-text class="pa-0"> 
              <v-row class="mr-2">
                <v-col cols="4">
                  <v-img
                    :src="scrplanwave[1]"
                    align="center"></v-img>
                </v-col>
                <v-col cols="4">
                  <v-row
                    v-for="item in mount"
                    :key="item"
                    align="stretch">
                    <v-card outlined class="pa-2" style="width: 100%;">
                      <p class="text-center my-auto caption">{{item}}</p>
                    </v-card>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row
                    v-for="item in especificaciones2"
                    :key="item"
                    align="stretch">
                    <v-card outlined class="pa-2" style="width: 100%;">
                      <p class="text-center my-auto caption">{{item}}</p>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="pa-2">
            <v-card-title style="background: #EA296A">
              <p class="body-2 white--text my-auto mx-auto">{{titulos[2]}}</p>
            </v-card-title>
            <v-card-text class="pa-0"> 
              <v-row class="mr-2">
                <v-col cols="4">
                  <v-img
                    :src="scrplanwave[2]"
                    align="center"></v-img>
                </v-col>
                <v-col cols="4">
                  <v-row
                    v-for="item in camera"
                    :key="item"
                    align="stretch">
                    <v-card outlined class="pa-2" style="width: 100%;">
                      <p class="text-center my-auto caption">{{item}}</p>
                    </v-card>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row
                    v-for="item in especificaciones3"
                    :key="item"
                    align="stretch">
                    <v-card outlined class="pa-2" style="width: 100%;">
                      <p class="text-center my-auto caption">{{item}}</p>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
    </v-dialog>
    <!--Fin Especificaciones Tecnicas-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      telescope: [
        "Aperture",
        "Focal Length",
        "Focal ratio",
        "Diameter Secondary Mirror",
        "Coating",
        "Optical Diameter Primary Mirror",
        "Central Obstruction"
      ],
      mount: [
        "Maximum load",
        "Latitude range",
        "Material",
        "Transmission system",
        "Guide speed",
        "Go-to speed",
        "Pointing accuracy"
      ],
      camera:[
        "Resolution",
        "Pixel size",
        "Image area",
        "Full well capacity",
        "Dark current",
        "Dark signal doubling temperature"
      ],
      especificaciones1: [
        "20 inch (508 mm)",
        "3454 mm (135.98 inch)",
        "F/6.8",
        "7.5 inch (191mm)",
        "Enhanced Aluminum - 96%",
        "20 inch (508 mm)",
        "39% of the Primary Mirror Diameter"
      ],
      especificaciones2: [
        "∼ 150kg",
        "23° – 70° adjustable with screw",
        "alloy steel",
        "backlash-free system with belt and automatic backlash recovery",
        "Adjustable from 0.1x to 1x",
        "4°/s max. r.a., 5°/s max. dec",
        "+/− 3”/4” typical without PEC"
      ],
      especificaciones3: [
        "3056 (H) × 3056 (V) pixels",
        "12 μm (H) × 12 μm (V)",
        "36.7 mm (H) × 36.7 mm (V)",
        "~110,000 e–",
        "~5 e–/s/pixel at 25 °C",
        "~7 °C"
      ],
      titulos: [
        "Telescope : Planewave CDK20",
        "Mount : 10micron GM4000-qci",
        "Camera : Moravian G4 9000 with filterwheel LRGB Halpha O III – S II"
      ],
      imagenes: [
        {
          src: require("../assets/planwave-1.png")
        },
        {
          src: require("../assets/planwave-2.png")
        },
        {
          src: require("../assets/planwave-3.png")
        }
      ],
      scrplanwave: [
        require("../assets/Planwave_specs/CDK20.jpg"),
        require("../assets/Planwave_specs/GM4000QCI.jpg"),
        require("../assets/Planwave_specs/moravian-camera.jpg")
      ],
      dialog: false
    };
  },
  components: []
};
</script>